import AudioManager from "../../Shared/AudioManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import Utils from "../../Shared/Utils";
import GameList from "../../Models/GameList";
import HallUI from "../HallUI";
import UIManager from "../../Shared/UIManager";
import Player from "../../Models/Player";
import TaskData from "./TaskData";
import data = cc.data;
import {Global} from "../../Shared/Global";
import find = cc.find;
import ActivityAndTask from "../Activity/ActivityAndTask";
import RechargeUI from "../Recharge/RechargeUI";
import ToggleItem from "../../Common/ToggleItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TaskLayer extends cc.Component {

    @property(cc.ScrollView)
    scrollView : cc.ScrollView = null;
    @property([cc.SpriteFrame])
    btnSpArr : cc.SpriteFrame[] = [];
    @property(cc.Node)
    detailLayer:cc.Node = null;
    @property(cc.ToggleContainer)
    titleContainer : cc.ToggleContainer = null;
    @property(cc.Node)
    leftItem:cc.Node = null;
    @property(cc.Node)
    rightContent : cc.Node = null;
    @property(cc.Node)
    rightItem:cc.Node = null;
    @property(cc.Node)
    rightLayer:cc.Node = null;
    @property(cc.Node)
    rightShareLayer:cc.Node = null;

    bPlayClick = false;
    private recommendData = null;
    private tempContent = null;
    private rightLayerArr = {};
    private redPoint: cc.Node = null;

    onLoad () {
        this.bPlayClick = false;
    }

    start() {
        cc.director.on(Global.UserEvent.UpdateShareRedPoint,this.updateShareRedPoint,this)
    }

    onDestroy(): void {
        cc.director.off(Global.UserEvent.UpdateShareRedPoint,this.updateShareRedPoint,this)
    }

    updateShareRedPoint(taskTypeId){
        let storageCopy = cc.sys.localStorage.getItem(Global.localStorageId.TaskCopy + Player.getPy("userID"));
        let storageSave = cc.sys.localStorage.getItem(Global.localStorageId.TaskSave + Player.getPy("userID"));
        let storageShare = cc.sys.localStorage.getItem(Global.localStorageId.TaskShare + Player.getPy("userID"));
        let storageSubmit = cc.sys.localStorage.getItem(Global.localStorageId.TaskSubmit + Player.getPy("userID"));
        let date = new Date();
        let shareRedPoint = 0;
        if (!storageCopy || storageCopy != "copy" + Player.getPy("userID") ||
            !storageSave || storageSave != "save" + Player.getPy("userID") ||
            !storageShare || storageShare != "share" + Player.getPy("userID") ||
            !storageSubmit || storageSubmit !== date.getUTCDate().toString() + Player.getPy("userID")
        ){
            shareRedPoint = 1;
        }
        NetworkLogic.taskGetTypes({},function (listType) {
            cc.log("===taskGetTypes:",listType);
            let titleChildren = this.titleContainer.node.children;
            for (let i = 0;i < listType.length;i++){
                for (let j = 0;j < titleChildren.length;j++){
                    let titleItem = titleChildren[j];
                    if (titleItem["taskTypeId"] === listType[i].taskTypeId){
                        let redPoint = titleItem.getChildByName("redPoint");
                        if(listType[i].finishCount > 0){
                            redPoint.active = true;
                            redPoint.getChildByName("labNum").getComponent(cc.Label).string = listType[i].finishCount + shareRedPoint ;
                        }else if (shareRedPoint > 0) {
                            this.redPoint.active = true;
                            redPoint.getChildByName("labNum").getComponent(cc.Label).string = shareRedPoint;
                        }else {
                            redPoint.active = false;
                        }
                        break;
                    }
                }
            }
        }.bind(this),function () {
            cc.log("===获取taskGetTypes类型错误:");
        })
    }


    async upateTaskLayer(recommendData?) {
        UIManager.showLoadingUI();
        let taskSwitch = await TaskData.getTaskMainSwitch();
        UIManager.hideLoadingUI();
        if (!taskSwitch){
            this.node.getChildByName("noData").active = true;
            return;
        }else {
            this.node.getChildByName("noData").active = false;
        }
        this.recommendData = recommendData;

        cc.log("=====upateTaskLayer");
        UIManager.showLoadingUI();
        let bOpen = await TaskData.getTaskMainSwitch();
        UIManager.hideLoadingUI();
        if (bOpen){
            UIManager.showLoadingUI();
            NetworkLogic.taskGetTypes({},function (rec) {
                UIManager.hideLoadingUI();
                cc.log("===taskGetTypes:",rec);
                this._setTitle(rec);
            }.bind(this),function () {
                UIManager.hideLoadingUI();
                cc.log("===获取taskGetTypes类型错误:");
            })
        }else{
            UIManager.showToastUI("任务活动已关闭！")
        }
    }

    _setTitle(listType=[]) {
        if (this.titleContainer.node.children.length > 0){
            return;
        }
        for (let i= 0;i < listType.length;i++) {//设置title
            let titleItem = cc.instantiate(this.leftItem);
            titleItem.active = true;
            titleItem.parent = this.titleContainer.node;
            titleItem["taskTypeId"] = listType[i].taskTypeId;
            titleItem.getComponent(cc.Toggle).checkEvents[0].customEventData = listType[i].taskTypeId;
            titleItem.getChildByName("labTitle").getComponent(cc.Label).string = listType[i].taskTypeName;
            if(listType[i].finishCount > 0){
                let redPoint = titleItem.getChildByName("redPoint");
                redPoint.active = true;
                redPoint.getChildByName("labNum").getComponent(cc.Label).string = listType[i].finishCount;
            }
            if (listType[i].taskTypeId === 8){// 分享标题增加角标
                this.redPoint = titleItem.getChildByName("redPoint");
                let storageCopy = cc.sys.localStorage.getItem(Global.localStorageId.TaskCopy + Player.getPy("userID"));
                let storageSave = cc.sys.localStorage.getItem(Global.localStorageId.TaskSave + Player.getPy("userID"));
                let storageShare = cc.sys.localStorage.getItem(Global.localStorageId.TaskShare + Player.getPy("userID"));
                let storageSubmit = cc.sys.localStorage.getItem(Global.localStorageId.TaskSubmit + Player.getPy("userID"));
                let date = new Date();
                if (!storageCopy || storageCopy != "copy" + Player.getPy("userID") ||
                    !storageSave || storageSave != "save" + Player.getPy("userID") ||
                    !storageShare || storageShare != "share" + Player.getPy("userID") ||
                    !storageSubmit || storageSubmit !== date.getUTCDate().toString() + Player.getPy("userID")
                ) {
                    this.redPoint.active = true;
                    this.redPoint.getChildByName("labNum").getComponent(cc.Label).string = "1";
                }
            }

        }

        if (this.recommendData) {// 如果是推荐任务，进入推荐任务toggle
            let toggleItems = this.titleContainer.toggleItems;
            for (let i = 0; i < toggleItems.length; i++) {
                if (toggleItems[i].checkEvents[0].customEventData === this.recommendData.taskTypeId) {
                    if (toggleItems[i].isChecked){
                        toggleItems[i].checkEvents[0].emit([toggleItems[i].checkEvents[0].customEventData]);
                    }else {
                        toggleItems[i].check();
                    }
                    break;
                }
            }
            this.recommendData = null;//用完置空数据
        } else {//没有推荐任务，进入第一个toggle
            let firstToggle = this.titleContainer.toggleItems[0];
            firstToggle.node.active = true;
            if (firstToggle.isChecked){
                firstToggle.checkEvents[0].emit([firstToggle.checkEvents[0].customEventData])
            }else {
                firstToggle.check();
            }
            //这里第一次会进两次，明天尝试不发事件
        }

    }


    //点击左边标题
    onToggleSelected(event, param, playSound = true) {
        this.scrollView.stopAutoScroll();
        cc.log("===进入onToggleSelected param：",param);
        if (this.bPlayClick){
            playSound && AudioManager.playSound("toggle");
        }else{
            this.bPlayClick = true;
        }
        if (parseInt(param) === 8) {//分享任务
            this.rightLayer.active = false;
            this.rightShareLayer.active = true;
            this.rightShareLayer.getComponent("TaskShare").updateUI(param);
        } else {
            this.rightShareLayer.active = false;
            this.rightLayer.active = true;
            cc.log("===param:", param);
            this._setRightLayer(param);
        }
    }

    async _setRightLayer(param) {
        let index = parseInt(param);
        let data = await TaskData.getList(index);
        if (!data) return;

        this.tempContent  && (this.tempContent.active = false);
        if (!this.rightLayerArr[param]) {

            let iconContent = cc.instantiate(this.rightContent);
            iconContent.parent = this.rightContent.parent;
            iconContent.active = true;
            this.rightLayerArr[param] = iconContent;

            for (let j = 0; j < data.length; j++) {//给所有内容赋值
                let iconItem = null;
                iconItem = cc.instantiate(this.rightItem);
                iconItem.parent = iconContent;
                let nodeNotmove = iconItem.getChildByName("nodeNotmove");
                let nameLabel = nodeNotmove.getChildByName("name").getComponent(cc.Label);
                nameLabel.string = data[j].taskName;
                nameLabel._forceUpdateRenderData(true);
                if  (nameLabel.node.width >= 400){
                    let str = Utils.handleNameLen(data[j].taskName,25);
                    nameLabel.string = str;
                }
                nodeNotmove.getChildByName("money").getComponent(cc.Label).string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): "" ) +  data[j].taskMoney;
                nodeNotmove.getChildByName("btnDetail").getComponent(cc.Button).clickEvents[0].customEventData = JSON.stringify(data[j]);
                let progressArr = data[j].alreadyMoney;
                let nodeProgress1 = iconItem.getChildByName("firstProgress");

                if (data[j].taskHandleStatus === -1 && progressArr[0] && progressArr[0].targetMoney) {//状态为-1 才有进度
                    let progress = 0;
                    nodeProgress1.getChildByName("nameNow").getComponent(cc.Label).string = progressArr[0].alreadyMoney + "/" + progressArr[0].targetMoney;
                        progress = progressArr[0].alreadyMoney/progressArr[0].targetMoney;
                    nodeProgress1.getChildByName("progressBar").getComponent(cc.ProgressBar).progress = progress;
                    if (progressArr.length === 2) {
                        let con = cc.find('secondProgress',iconItem);
                        con.active = true;
                        con.getChildByName("nameNow").getComponent(cc.Label).string = progressArr[1].alreadyMoney + "/" + progressArr[1].targetMoney;
                        progress = progressArr[1].alreadyMoney / progressArr[1].targetMoney;
                        con.getChildByName("progressBar").getComponent(cc.ProgressBar).progress = progress;
                        con.getChildByName("labContent").getComponent(cc.RichText).string  =this.addRichColor(Utils.handleNameLen(data[j].alreadyMoney[1].planName,38))
                    }else if (progressArr.length === 1){
                        cc.find('secondProgress',iconItem).active = false;
                    }
                } else {
                    nodeProgress1.getChildByName("nameNow").getComponent(cc.Label).string = "";
                    nodeProgress1.getChildByName("progressBar").getComponent(cc.ProgressBar).progress = 1;
                }
                let richText = nodeProgress1.getChildByName("labContent").getComponent(cc.RichText);
                let text = data[j].alreadyMoney[0].planName;
                let str = Utils.handleNameLen(text,38);
                richText.string = this.addRichColor(str);
                iconItem['taskId'] = data[j].taskId;
                let strBtnName = TaskData.getBtnType(data[j].taskHandleStatus);
                let btnGo = nodeNotmove.getChildByName("btnGo").getComponent(cc.Button);
                if (data[j].taskHandleStatus >= 0) {
                    btnGo.node.getComponent(cc.Sprite).spriteFrame = this.btnSpArr[data[j].taskHandleStatus];
                }
                btnGo.node.getChildByName("btnGo_label").getComponent(cc.Label).string = strBtnName;
                btnGo.clickEvents[0].customEventData = JSON.stringify(data[j]);
                btnGo.interactable = TaskData.getBtnInteractable(data[j].taskHandleStatus);
                iconItem.active = true;
                if (data[j].taskHandleStatus === 3) {//可领取
                    nodeNotmove.getChildByName("redPoint").active = true;
                }
            }
            for (let k = 0; k < data.length; k++) {
                let iconItem = this.rightLayerArr[param].children[k];
                this.getImage(data[k].logo, iconItem);
            }

        }else {
            this.rightLayerArr[param].active = true;
        }
        this.tempContent = this.rightLayerArr[param];
        this.scrollView.content = this.rightLayerArr[param];


    }


    getImage(url,iconItem){
        cc.loader.load(url, function (err, texture) {
            if (!err && this.node) {
                if (cc.isValid(iconItem)){
                    cc.find("nodeNotmove/mask/icon",iconItem).getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture);
                }
            }else {

            }
        }.bind(this))
    }

    onBtnGo(event,param){
        AudioManager.playSound("button");
        if(!Player.isLogedIn()){
            this.node.parent.parent.getComponent("ActivityAndTask").onBtnClose();
            let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
            hallUI.checkLoginAndShowUI();
            this.node.parent.parent.getComponent("ActivityAndTask").onBtnClose();
            return;
        }
        param = JSON.parse(param);
        if (param.bindWechat === 1){
            if (!Player.getPy("serverData").hasWechat){
                UIManager.showConfirmUI("请先绑定微信",
                    function () {
                        let hallUI : HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                        let tuiguang = hallUI.openChildUI(hallUI.pfbTuiGuang);
                        let tuiGuangLayer = tuiguang.getComponent("TuiGuangLayer");
                        tuiGuangLayer.jumpBindWechat  = true;
                        tuiGuangLayer.updateUI();
                        this.node.parent.parent.getComponent("ActivityAndTask").onBtnClose();
                    }.bind(this),
                    "立即前往");

                return;
            }
        }
        if (param.taskHandleStatus === -1){//去完成
            this.jumpOut(param);
            this.node.parent.parent.getComponent("ActivityAndTask").onBtnClose();
        }else {//
            let data = {"taskId": param.taskId};
            UIManager.showLoadingUI();
            NetworkLogic.taskGetAward(data,function (rec) {
                UIManager.hideLoadingUI();
                cc.log("=====taskGetAward rec:",rec);
                event.target.getChildByName("btnGo_label").getComponent(cc.Label).string = TaskData.getBtnType(rec.status);
                event.target.getComponent(cc.Button).interactable = TaskData.getBtnInteractable(rec.status);
                event.target.getComponent(cc.Sprite).spriteFrame = this.btnSpArr[rec.status];
                event.target.parent.getChildByName("redPoint").active = false;
                if (param.taskHandleStatus === 3){//可领取
                    cc.director.emit(Global.UserEvent.UpdateMoney);
                    cc.director.emit(Global.UserEvent.OpenBaoxiang,rec.taskMoney);
                    cc.director.emit(Global.UserEvent.UpdateShareRedPoint,param.taskId);//更新红点

                }else if(param.taskHandleStatus === 4){//申请
                    UIManager.showToastUI("申请成功，请等待审核！")
                }
                TaskData.ListType = {};//数据改变，重置数据
            }.bind(this),function () {

            }.bind(this))
        }
    }

    //任务详情
    onBtnDetail(event,param){
        AudioManager.playSound("button");
        param = JSON.parse(param);
        let activityAndTask :ActivityAndTask = this.node.parent.parent.getComponent("ActivityAndTask");
        let taskDetail = activityAndTask.openChildUI(activityAndTask.TaskDetail);
        taskDetail.getComponent("TaskDetail").updateUI(param);

    }


    addRichColor(text){
        let res = new RegExp("\\d+", 'g');
        if (res.test(text)) {
            let matchArr = text.match(res);
            text = text.replace(/\d+/g, "&")
            for (let i = 0; i < matchArr.length; i++) {
                text = text.replace("&","<color =#FF2626>" + matchArr[i] + "</color>");
            }
        }
        return text;
    }



    jumpOut(param){//跳转
        let taskConditionConfig = JSON.parse(param.taskConditionConfig)[0] ;
            cc.log("====jumpOut taskConditionConfig:",taskConditionConfig);
        if (taskConditionConfig.conditionType === 1){//跳充值界面；
            let hallUI : HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
            let pfbRechargeUI = hallUI.openChildUI(hallUI.pfbRechargeUI, true);
            let rechargeUI : RechargeUI = pfbRechargeUI.getComponent("RechargeUI");
            rechargeUI.bJump = true;
            rechargeUI.jumpChargeTypeId = taskConditionConfig.conditionDeposit.depositType;
        }else if (taskConditionConfig.conditionType === 2 ){//跳转游戏
            this._jumpToGame(taskConditionConfig.conditionBet)
        }else if (taskConditionConfig.conditionType === 3){
            this._jumpToGame(taskConditionConfig.conditionPlayTimes)
        }else if (taskConditionConfig.conditionType === 4){
            this._jumpToGame(taskConditionConfig.conditionLoss)
        }

    }


    _jumpToGame(data){
        if (data.gameType === 0){//跳游戏首页
            cc.log("===跳转到首页");
        }else if (data.gamePlat === "ALL"){//游戏平台为All,跳转到对应游戏类型；
            this.clickGamType(data);
        }else if (data.gameListId === 0){//跳转到对应平台
            this.clickGamType(data);
            this.clickGamePlat(data);
        }else if(data.gameListId != 0){//进入对应三方游戏
            let hallUI : HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
            let gameConfig = GameList.getGameConfigById(data.gameType,data.gamePlat);
            UIManager.showLoadingUI()
            if (gameConfig.entranceFlag === 0){
                hallUI.enterGame(gameConfig);
            }else{
                NetworkLogic.getGameList(gameConfig.id, function (gameConfigs) {
                    UIManager.hideLoadingUI();
                    let gameList = gameConfigs.tabList;
                    for (let i = 0;i < gameList.length;i++){
                        if (gameList[i].gameListId === data.gameListId){
                            hallUI.enterGame(gameList[i]);
                            break;
                        }
                    }
                }.bind(this))
            }
        }
    }

    //点击对应大类
    clickGamType(data){
        let filtercontent = cc.find("Canvas/gameNode/gameTypes/node/view/content")
        let toggleItems = filtercontent.getComponent(cc.ToggleContainer).toggleItems
        let name = Utils.gameTypeToLayer(data.gameType);
        for (let i = 0;i < toggleItems.length;i++){
            if (toggleItems[i].node.name === name){
                toggleItems[i].check();
                break;
            }
        }
    }

    //点击对应游戏大类下的某平台，弹出thirdGameList
    clickGamePlat(data){
        let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
        let gameConfig = this.getGameConfig(data);
        gameConfig && hallUI.enterGame(gameConfig);
    }

    getGameConfig(jumpGame){
        let tabList = GameList.serverData["tabList"];
        for (let i = 0;i < tabList.length;i++){
            for (let j = 0;j < tabList[i].twoLevelList.length;j++){
                let gameConfig = tabList[i].twoLevelList[j];
                if (gameConfig.platform === jumpGame.gamePlat && gameConfig.platformGameType === jumpGame.gameType){
                    return gameConfig;
                }
            }
        }
    }

    onTaskDetailClose(){
        this.detailLayer.active = false;
    }

}
